import { render, staticRenderFns } from "./ListOwnerShip.vue?vue&type=template&id=3fb0a459"
import script from "./ListOwnerShip.vue?vue&type=script&lang=js"
export * from "./ListOwnerShip.vue?vue&type=script&lang=js"
import style0 from "./ListOwnerShip.vue?vue&type=style&index=0&id=3fb0a459&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports